import {
  structuredErrorToFieldErrorPairs,
  StructuredError,
} from '../../services/BaseBackendService';
import { PlaceholderContactProps } from '../../models/PlaceholderContact';
import { PlaceholderContactEditFormFields, SelectOption } from './placeholderContactAdminTypes';

export const PLACEHOLDER_ROLE_OPTIONS: SelectOption[] = [
  { value: 'OWNER', label: 'Owner' },
  { value: 'REPRESENTATIVE', label: 'Representative' },
];

export const REPRESENTATIVE_TYPE_OPTIONS: SelectOption[] = [
  { value: 'FAMILY', label: 'Family' },
  { value: 'WEALTH_MANAGER', label: 'Wealth Manager' },
  { value: 'ADVISOR', label: 'Advisor' },
  { value: 'ACCOUNTANT', label: 'Accountant' },
  { value: 'LEGAL_COUNSEL', label: 'Legal Counsel' },
  { value: 'TAX_ADVISOR', label: 'Tax Advisor' },
  { value: 'OTHER', label: 'Other' },
];

export function editFormFieldsFromPlaceholder(
  placeholder: PlaceholderContactProps,
): PlaceholderContactEditFormFields {
  return {
    firstName: placeholder.firstName,
    lastName: placeholder.lastName,
    email: placeholder.email,
    role: placeholder.role,
    representativeType: placeholder.representativeType,
    otherRepresentativeType: placeholder.otherRepresentativeType,
  };
}

export function clearValidationErrorForField(
  validationErrors: Record<string, string>,
  field: keyof PlaceholderContactEditFormFields,
): Record<string, string> {
  const nextErrors: Record<string, string> = {};
  Object.keys(validationErrors).forEach((key) => {
    if (key !== field) {
      nextErrors[key] = validationErrors[key];
    }
  });
  return nextErrors;
}

export function parseUpdatePlaceholderError(error: unknown): {
  validationErrors: Record<string, string>;
  message: string;
} {
  const structured = error as { structuredError?: boolean; error?: string };
  if (structured.structuredError) {
    return {
      validationErrors: structuredErrorToFieldErrorPairs(error as StructuredError),
      message: 'Please correct the errors below',
    };
  }

  return {
    validationErrors: {},
    message: structured.error || 'Failed to update placeholder contact',
  };
}

export function parsePromotePlaceholderError(error: unknown): {
  validationErrors: Record<string, string>;
  message: string;
  switchToEditMode: boolean;
} {
  const structured = error as { structuredError?: boolean; error?: string };
  if (structured.structuredError) {
    return {
      validationErrors: structuredErrorToFieldErrorPairs(error as StructuredError, {
        duplicateFields: {
          email:
            "This email is already in use, you can leave it blank if you don't want to use the contact below that already has this email",
        },
      }),
      message: 'Please correct the errors below before promoting',
      switchToEditMode: true,
    };
  }

  return {
    validationErrors: {},
    message: structured.error || 'Failed to promote placeholder contact',
    switchToEditMode: false,
  };
}
